"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TriviaDeckLinkWrapper = function TriviaDeckLinkWrapper(Component) {
  var _class, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)((_class = /*#__PURE__*/function (_React$Component) {
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class, [].concat(args));
      _initializerDefineProperty(_this, "showTriviaOpponentsModal", _descriptor, _this);
      _initializerDefineProperty(_this, "pendingDeckId", _descriptor2, _this);
      _this.onClickPlayTrivia = function () {
        if (_state.AppUI.layout.isNative && _this.props.routeToDeck && !_this.shouldShowTriviaOpponentsModal) {
          _this.props.routeToDeck({
            treeNodeId: _this.props.treeNode.id,
            chooseTriviaDeck: true
          });
          return;
        }
        _state.TreeUI.onClickPlayTrivia({
          treeNodeId: _this.props.treeNode.id,
          callback: _this.afterChooseDeck
        });
      };
      _this.persistTriviaSettings = function (data) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash.noop;
        if (Object.keys(data).length === 0) {
          callback();
          return;
        }
        _state.AppUI.authUserStore.update({
          data: data
        }, callback);
      };
      _this.routeToDeck = function (deckId) {
        _state.TreeUI.set('clickedPlayRandomOpponent', false);
        if (_state.AppUI.layout.isNative) {
          if (_this.props.routeToDeck && deckId) {
            _this.props.routeToDeck({
              deckId: deckId
            });
          }
        } else if (deckId) {
          _state.TreeUI.routeStore.routeToNamed('trivia.tree_nodes.decks.show', {
            treeNodeId: _this.props.treeNode.id,
            deckId: deckId
          });
        }
      };
      _this.closeTriviaOpponentsModal = function () {
        _this.showTriviaOpponentsModal = false;
        _this.pendingDeckId = null;
        _state.TreeUI.set('clickedPlayRandomOpponent', false);
      };
      _this.onSelectPlayMode = function (playWithOpponents) {
        var deckId = _this.pendingDeckId;
        var data = {};
        _this.showTriviaOpponentsModal = false;
        _this.pendingDeckId = null;
        if (!_state.AppUI.user.wasUiElementSeen('trivia-opponents-toggle')) {
          _state.AppUI.user.designateUiElementAsSeen('trivia-opponents-toggle');
          data.ui_elements_seen = _state.AppUI.user.uiElementsSeen;
        }
        if (_state.AppUI.user.playTriviaWithOpponents !== playWithOpponents) {
          _state.AppUI.user.set('playTriviaWithOpponents', playWithOpponents);
          data.playTriviaWithOpponents = playWithOpponents;
        }
        _this.persistTriviaSettings(data, function () {
          return _this.routeToDeck(deckId);
        });
      };
      _this.onSelectPlayWithOpponents = function () {
        _this.onSelectPlayMode(true);
      };
      _this.onSelectPlaySolo = function () {
        _this.onSelectPlayMode(false);
      };
      _this.afterChooseDeck = function (resp) {
        if (resp.deckId && _this.shouldShowTriviaOpponentsModal) {
          _this.pendingDeckId = resp.deckId;
          _this.showTriviaOpponentsModal = true;
        } else {
          _this.routeToDeck(resp.deckId);
        }
      };
      return _this;
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "sentencesSeenCount",
      get: function get() {
        if (_state.AppUI.userIsLoaded) {
          return (0, _utils.isPresent)(this.props.userTreeNode) ? this.props.userTreeNode.sentencesSeenCount : 0;
        }
      }
    }, {
      key: "showNewLabel",
      get: function get() {
        var _this$props$treeNode, _this$props$treeNode2;
        return (0, _utils.isPresent)((_this$props$treeNode = this.props.treeNode) === null || _this$props$treeNode === void 0 ? void 0 : _this$props$treeNode.daysSinceLastTriviaUpdate) && ((_this$props$treeNode2 = this.props.treeNode) === null || _this$props$treeNode2 === void 0 ? void 0 : _this$props$treeNode2.daysSinceLastTriviaUpdate) < 2;
      }
    }, {
      key: "shouldShowTriviaOpponentsModal",
      get: function get() {
        return this.props.showFirstOpenTriviaModal && _state.AppUI.userIsLoaded && !_state.AppUI.wasUiElementSeen('trivia-opponents-toggle');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentencesSeenCount: this.sentencesSeenCount,
          showNewLabel: this.showNewLabel,
          onClickPlayTrivia: this.onClickPlayTrivia,
          showTriviaOpponentsModal: this.showTriviaOpponentsModal,
          onCloseTriviaOpponentsModal: this.closeTriviaOpponentsModal,
          onSelectPlayWithOpponents: this.onSelectPlayWithOpponents,
          onSelectPlaySolo: this.onSelectPlaySolo,
          description: "Would you like to compete against other players in our trivia games?",
          settingsNote: "You can change this in your deck settings at any time."
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showTriviaOpponentsModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pendingDeckId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "sentencesSeenCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sentencesSeenCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNewLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldShowTriviaOpponentsModal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowTriviaOpponentsModal"), _class.prototype), _class));
};
TriviaDeckLinkWrapper.displayName = 'TriviaDeckLinkWrapper';
var _default = exports["default"] = TriviaDeckLinkWrapper;